import type { EffectDefinition } from "./effectTypes";

export type NoiseParameters = {
  amount: number;
  monochrome: boolean;
  seed: number;
};

export const noiseDefinition: EffectDefinition<NoiseParameters> = {
  id: "noise",
  version: 1,
  name: "Noise / Grain",
  category: "texture",
  description: "Deterministic grain for print texture, surface breakup, and motion-safe noise.",
  parameters: [
    { id: "amount", label: "Amount", type: "number", min: 0, max: 1, step: 0.01 },
    { id: "monochrome", label: "Monochrome", type: "boolean" },
    { id: "seed", label: "Seed", type: "number", min: 0, max: 9999, step: 1 },
  ],
  defaults: {
    amount: 0.18,
    monochrome: true,
    seed: 137,
  },
  capabilities: {
    image: true,
    video: true,
    vector: false,
    gpu: true,
  },
};
